// import saga helpers
import { put, takeLatest, call, all } from "redux-saga/effects";

import { CUSTOMER_CARD_ADDED, GET_CUSTOMER_CARDS } from "./actionType";
import {
  customerCardAddedSuccess,
  customerCardAddedError,
  getCustomerCardsSuccess,
  getCustomerCardsError,
} from "./action";

import {
  customerCardAddSuccessApiCall,
  getCustomerCardsApiCall,
} from "../../helpers/fakebackend_helper";

export function* customerCardAddSuccessCall(action) {
  try {
    const response = yield call(customerCardAddSuccessApiCall, action.payload);
    yield put(customerCardAddedSuccess(response));
  } catch (error) {
    yield put(customerCardAddedError(error));
  }
}

export function* watcherCustomerCardAddSuccessSaga() {
  yield takeLatest(CUSTOMER_CARD_ADDED, customerCardAddSuccessCall);
}

// Get Customer Cards List
export function* getCustomerCardsCall() {
  try {
    const response = yield call(getCustomerCardsApiCall);
    yield put(getCustomerCardsSuccess(response));
  } catch (error) {
    yield put(getCustomerCardsError(error));
  }
}

export function* watcherGetCustomerCardsSaga() {
  yield takeLatest(GET_CUSTOMER_CARDS, getCustomerCardsCall);
}

export function* Charges() {
  yield all([
    watcherCustomerCardAddSuccessSaga(),
    watcherGetCustomerCardsSaga(),
  ]);
}

export default Charges;
